import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import type { Props } from './types';
import messages from '../messages';

function RunCriminalScreeningModal({
  intl,
  open,
  isSubmitting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={intl.formatMessage(messages.runCriminalScreeningTitle)}
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            {intl.formatMessage(messages.cancel)}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isSubmitting}>
            {intl.formatMessage(messages.confirm)}
          </Button>
        </>
      }
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 480,
            },
          },
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="bodyMedium">
          {intl.formatMessage(messages.runCriminalScreeningBody1)}
        </Typography>
        <Typography variant="bodyMedium">
          {intl.formatMessage(messages.runCriminalScreeningBody2)}
        </Typography>
      </Stack>
    </Modal>
  );
}

export default RunCriminalScreeningModal;
